import {useQuery} from "@tanstack/react-query";
import Api, {initApis} from "../api/Api";
import {QUERY_KEYS} from "./queryKeys";
import {type IConfig} from "../types/config";
import {type AntiForgeryToken} from "../api/endpoints/Auth";

export const useConfigQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.config],
    queryFn: async () => {
      try {
        return await initApis();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    staleTime: Infinity,
    retry: 3,
  });
};

export const useAntiForgeryToken = (enabled: boolean) => {
  return useQuery({
    queryKey: [QUERY_KEYS.user.antiForgeryToken],
    queryFn: () => Api.auth.getAntiForgeryToken(),
    enabled: enabled
  });
};

type ConfigQueryType<Data, Error> = {
  isLoading: boolean;
  data: Data | undefined;
  error: Error | null;
}

export type useInitiateConfigQueryType = {
  config: ConfigQueryType<IConfig, Error>;
  antiForgeryToken: ConfigQueryType<AntiForgeryToken | void, Error>;
}

export const useInitiateConfigQuery = (): useInitiateConfigQueryType => {
  const configQuery = useConfigQuery();
  const antiForgeryTokenQuery = useAntiForgeryToken(Boolean(configQuery.data));

  return {
    config: {
      isLoading: configQuery.isLoading,
      data: configQuery.data,
      error: configQuery.error,
    },
    antiForgeryToken: {
      isLoading: antiForgeryTokenQuery.isLoading,
      data: antiForgeryTokenQuery.data,
      error: antiForgeryTokenQuery.error,
    }
  };
};
